import { LocationService } from '@utility/services';
import { useEffect, useState } from 'react';
import type { WarehouseLocationLabelDataType } from 'types/warehoue/label';

type LabelHistoryResponse = {
  data?: WarehouseLocationLabelDataType;
};

type WarehouseLocationLabelHookReturnType = {
  loading: boolean;
  error: string | null;
  data?: WarehouseLocationLabelDataType;
};

export const WarehouseLocationLabelHook = (
  warehouseId?: string,
): WarehouseLocationLabelHookReturnType => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<WarehouseLocationLabelDataType>();

  const fetchData = async () => {
    try {
      setLoading(true);
      const res: LabelHistoryResponse = await LocationService.getWarehouseLocationLabel({
        warehouseId,
      });
      setData(res.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!warehouseId) return;

    fetchData();
  }, [warehouseId]);

  return { loading, error, data };
};
